import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { colors, typography } from '../styles';
import HeaderMenu from './HeaderMenu';
import ContactModal from './ContactModal';
// import Search from './Search';

const styles = css`
  height: 60px;
  position: fixed;
  top: 0;
  width: 100%;
  background-color: #FFFFFF;
  z-index: 50;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;

  @media (min-width: 992px) {
    height: 80px;
  }
  .Header_logo {
    display: inline-block;
    width: 170px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 600;

    @media (min-width: 992px) {
      background-color:white;
      width: 320px;
    }
    img {
      width: 100%;
    }
  }
  .action-set {
    width: auto;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
  }
  .Header_search {
    position: absolute;
    right: 60px;
    top: 10px;
    z-index: 2;
    @media (min-width: 992px) {
      right: 0;
      top: 0;
    }
  }
  .Header_searchButton {
    width: 30px;
    height: 30px;
    border: 0;
    background-color: #FFFFFF;
    background-image: url('/images/icon-search.svg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto 24px;
    @media (min-width: 992px) {
      height: 100px;
      width: 80px;
    }
  }
  .Header_searchResults {
    width: 100%;
    background-color: #000000;
    padding: 15px;
    position: fixed;
    top: 50px;
    left: 0;
    @media (min-width: 992px) {
      width: 300px;
      right: 0;
      top: 100px;
      left: auto;
    }
    input {
      width: 100%;
      padding: 4px 8px;
    }
    .results {
      list-style: none;
      margin: 10px 0 0 0;
      padding: 0;
      height: 200px;
      overflow-y: scroll;
      background-color: #FFFFFF;
      a {
        display: block;
        padding: 5px 10px;
        font-size: 14px;
        line-height: 1.1;
      }
    }
  }
  .Header_menuToggle {
    width: 54px;
    height: 32px;
    border: 0;
    background-color: #FFFFFF;
    background-image: url('/images/icon-menu.svg');
    background-position: center center;
    background-repeat: no-repeat;
    margin: 14px 10px 0 0;
    background-size: 80%;
    cursor:pointer;
    @media (min-width: 992px) {
      margin: 24px;
      background-size: 100%;
    }
  }
  .OSCTag_wrapper {
    display: none;
    @media (min-width: 992px) {
      display: block;
      background-color: #000000;
      cursor: pointer;
      z-index: 1;
    }
  }
  .OSCTag_image {
    width: 80px;
    height: 80px;
    float: left;
    background-color: #eeeeee;
    background-image:url('/images/icon-menu.svg');
    background-size:cover;
    background-position:center;
  }
  .OSCTag_content {
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    padding:10px 30px;
    height:80px;
    background-color: ${colors.color1};
    transition: all .25s ease;
  }
  .OSCTag_content:hover {
    background-color: ${colors.color1Darkest};
  }
  .OSCTag_headline {
    color: #FFFFFF;
    font:700 24px/1 ${typography.SansSerif};
    padding-bottom:5px;
  }
  .OSCTag_phone {
    color: #FFFFFF;
    font:400 18px/1 ${typography.SansSerif};
  }
`;

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuActive: false,
    };
  }

  toggleMenu = () => {
    this.setState({
      menuActive: !this.state.menuActive,
    });
  }

  render() {
    const { builder, widget } = this.props;
    const { menuActive } = this.state;
    return (
      <div className={styles}>
        <Link className="Header_logo" name="index">
          <img src="/images/header-logo-dark.jpg" alt={builder.name} />
        </Link>
        {/* <div className="Header_search">
          <ToggleElement
            button={<button className="Header_searchButton" />}
          >
            <Search className="Header_searchResults" />
          </ToggleElement>
        </div> */}
        <HeaderMenu isActive={menuActive} toggleMenu={this.toggleMenu} />
        <div className="action-set">
          <button className="Header_menuToggle" onClick={this.toggleMenu} />
          <ContactModal builder={builder}>
            <div className="OSCTag_wrapper">
              {get(widget, 'photo.contentUrl') &&
                <div className="OSCTag_image" style={{ backgroundImage: `url(${buildThumbnailUrl(get(widget, 'photo.contentUrl'), { width: 140, height: 140, preserve: true })})` }} />
              }
              <div className="OSCTag_content">
                <div className="OSCTag_headline">
                  {widget.headline}
                </div>
                <div className="OSCTag_phone">
                  {builder.telephone}
                </div>
              </div>
            </div>
          </ContactModal>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  builder: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default withData(
  {
    builder: true,
    widget: 'osc_info',
  },
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js